<template>
  <v-select
    :id="id"
    :options="companies"
    :filterable="false"
    label="title"
    v-model="selectedCompany"
    @search="onSearch"
    :placeholder="placeholder"
    >
    <template slot="no-options">
      {{noOptionsText}}
    </template>
    <template slot="option" slot-scope="option">
        <span class="text-black text-uppercase font-weight-bold company-search-name">{{option.title}}</span><br>
        <small class="text-blue ml-1 text-truncate">{{option.address_snippet}}</small>
    </template>
  </v-select>
</template>

<script>
import _ from 'lodash'
import proxy from '@/api/proxy'

export default {
  name: 'CompanySelector',
  data: function () {
    return {
      companies: []
    }
  },
  props: ['id', 'value', 'placeholder', 'noOptionsText'],
  computed: {
    selectedCompany: {
      get: function () {
        return this.value
      },
      set: function (value) {
        if (value !== this.value) {
          this.$emit('input', value)
        }
      }
    }
  },
  methods: {
    onSearch (search, loading) {
      loading(true)
      this.search(loading, search, this)
    },
    search: _.debounce((loading, search, vm) => {
      proxy.searchCompanies({
        q: search
      }).then(response => {
        vm.companies = _.map(response.items, company => _.pick(company, 'title', 'address_snippet', 'company_number'))
      }).finally(() => {
        loading(false)
      })
    }, 350)
  }
}
</script>
